/**

 * DEVELOPER DOCUMENTATION & INFO
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/*
Also Bought Custom JS
====================================*/
// Default variant selection
function selectVariantOverride() {
  document.getElementById('AddToCart').removeAttribute('disabled');
  document.querySelector('.shopify-product-form .loader-button__text').textContent = 'Add to Cart';
}

document.addEventListener('DOMContentLoaded', function () {
  // Event listener for "Also Bought" Add to Cart buttons
  document.querySelectorAll('.rokform-also-bought .plug-product-upsell-item__add-btn').forEach(button => {
    button.addEventListener('click', function (e) {
      console.log('also bought');
      e.preventDefault();
      const variantId = parseInt(this.getAttribute('data-variant-id'));
      const variantIdString = variantId.toString();
      const elem = this;

      const spinnerElement = elem.querySelector('.loader-button__loader');
      const addBtnText = button.querySelector('.plug-product-upsell-item__add-btn-text');
      addBtnText.hidden = true;
      spinnerElement.hidden = false;
      const spinnerAnimation = spinnerElement.animate({
        opacity: [0, 1],
        transform: ["translate(-50%, 0%)", "translate(-50%, -50%)"]
      }, {
        duration: 75,
        delay: 75,
        easing: "ease",
        fill: "forwards"
      });
      this._startTransitionPromise = Promise.all([
        new Promise((resolve) => spinnerAnimation.onfinish = () => resolve())
      ]);

      document.querySelectorAll('.rokform-also-bought .plug-product-upsell-item__add-btn').forEach(button => {
        button.setAttribute('disabled', 'disabled');
      });

      if (elem.classList.contains('added')) {
        // Remove from cart
        console.log('remove item from cart');
        let data = new URLSearchParams({ "id": variantIdString, "quantity": 0 });

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: data
        })
        .then(response => response.json())
        .then(cart => {
          console.log('removed');
          document.querySelectorAll('.rokform-also-bought .plug-product-upsell-item__add-btn').forEach(button => {
            button.removeAttribute('disabled');
          });
          elem.innerHTML = `<span class="plug-product-upsell-item__add-btn-text">+ Add</span>
                  <span class="loader-button__loader" hidden>
                    <div class="spinner">
                      <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                        <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                      </svg>
                    </div>
                  </span>`;
          elem.classList.remove('added');

          document.dispatchEvent(new CustomEvent("cart-notification:show", {
            bubbles: true,
            cancelable: true,
            detail: { status: "error", error: "Item removed from cart" }
          }));

          fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            document.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { cart: cart }
            }));
            document.querySelectorAll('.rokform-also-bought .plug-product-upsell-item__add-btn').forEach(button => {
              button.removeAttribute('disabled');
              const spinnerElement = button.querySelector('.loader-button__loader');
              spinnerElement.hidden = true;
            });
          });
        });

      } else {
        // Add to cart
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({ "quantity": 1, "id": variantId })
        })
        .then(response => response.json())
        .then(cart => {
          console.log('added');
          elem.closest('.plug-product-upsell-item').hidden = true;

          elem.innerHTML = `<span class="plug-product-upsell-item__add-btn-text">&#x2713;</span>
          <span class="loader-button__loader" hidden>
            <div class="spinner">
              <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
              </svg>
            </div>
          </span>`;
          elem.classList.add('added');
          document.dispatchEvent(new CustomEvent("cart-notification:show", {
            bubbles: true,
            cancelable: true,
            detail: { status: "success", error: "Error" }
          }));

          fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { 
                cart: cart,
                openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer") === null
              }
            }));
            document.querySelectorAll('.rokform-also-bought .plug-product-upsell-item__add-btn').forEach(button => {
              button.removeAttribute('disabled');
            });
          });
        });
      }
    });
  });

  // Mini cart event listener
  document.getElementById('mini-cart').addEventListener('click', function (event) {
    if (event.target.classList.contains('plug-product-upsell-item__add-btn')) {
      const variantId = parseInt(event.target.getAttribute('data-variant-id'));
      const elem = event.target;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ "quantity": 1, "id": variantId })
      })
      .then(response => response.json())
      .then(cart => {
        elem.innerHTML = '&#x2713;';
        elem.classList.add('added');

        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { cart: cart }
          }));
          checkMiniCartRecommendations();
        });
      });
    }
  });
});

// Function to check mini cart recommendations
function checkMiniCartRecommendations() {
  console.log('checkMiniCartRecommendations');
  return;

  setTimeout(() => {
    if (document.querySelector('.shopify-section--main-product')) {
      let elemToCopy = document.querySelector('.shopify-section--main-product .rokform-also-bought').cloneNode(true);
      let htmlToCopy = document.querySelector('.shopify-section--main-product .rokform-also-bought').cloneNode(true);
      document.querySelector('#mini-cart .drawer__content .rokform-also-bought').innerHTML = '';
      document.querySelector('#mini-cart .drawer__content .rokform-also-bought').appendChild(htmlToCopy);
    }
  }, 1000);
}

// Variant Image Switcher
document.addEventListener('variant:changed', function (event) {
  let variant = event.detail.variant;
  console.log(variant);

  document.querySelectorAll('product-media .product__media-nav img').forEach(img => {
    if (variant.option1 === img.getAttribute('alt')) {
      console.log('find ' + img.getAttribute('alt') + ' and click');
      img.closest('button').click();
    }
  });
});

